<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "counter",
  data() {
    return {};
  },
  created() {}
};
</script>
